export default __webpack_public_path__ + "static/media/banner2.21817224.jpg";